import React from "react";
import PropTypes from "prop-types";
import PieChart from "react-minimal-pie-chart";

import DonutPercentage from "./DonutPercentage";
import { blue50, black20 } from "./DonutChart.module.scss";

const DonutChart = ({ score, scoreMax, color, className }) => {
  scoreMax = scoreMax || 1;

  const segments = [
    {
      showLabel: true,
      value: score,
      percent: (score / scoreMax),
      color: color,
      style: { strokeWidth: 14 }
    },
    {
      value: scoreMax - score,
      color: black20,
      style: { strokeWidth: 4 }
    }
  ];

  return (
    <PieChart
      className={className}
      startAngle={-90}
      lengthAngle={-360}
      data={segments}
      segmentsStyle={{ transition: "stroke-width .1s" }}
      label={({ key, data, dataIndex }) => data[dataIndex].showLabel && (
        <DonutPercentage key={key} {...data[dataIndex]} />
      )}
      labelPosition={0}
      animate={false}
      radius={80}
      totalValue={scoreMax}
    />
  );
};

DonutChart.defaultProps = {
  color: blue50
};

DonutChart.propTypes = {
  score: PropTypes.number.isRequired,
  scoreMax: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
};

export default DonutChart;
